import { withJsonFormsControlProps } from '@jsonforms/react'
import { widgetTester, WidgetDisplay } from '../widget/Widget'

export const widgetDisplay = {
  tester: widgetTester,
  renderer: withJsonFormsControlProps(WidgetDisplay),
}

export const widgetDisplayRenderer = {
  widget: {
    tester: widgetTester,
    renderer: withJsonFormsControlProps(WidgetDisplay),
  },
}
